import React from 'react';
import ContentGrid from './ContentGrid';

const ContentGridWithProps = (props: any) => {
  return (
    <ContentGrid
      sectionTitle={props.sectionTitle}
      sectionDescription={props.sectionDescription}
      gridItems={props.gridItems}
      ctaLabel={props.ctaLabel}
      ctaLink={props.ctaLink}
      theme={props.theme}
    />
  );
};

export default ContentGridWithProps;
